
import _ from 'lodash'
import { GetDefaultParentType } from '../constants/ProConstants';
import { AddDays, GetDurationInDays } from "../utilities/DateHelper";
import { useHierarchyService } from './useHierarchyService';

const useCensusForm = ({formik})=>{

    const {actions:{SetCurrentLocation, OnBuildingChanged, OnParentTypeChanged, OnParentChanged, OnRoomChanged}}  = useHierarchyService();
   

    const onChanged = (e)=>{
        let calculatedEndDate        
        switch(e.target.id){
            case "startDate":  
                formik.setValues({ ...formik.values, startDate:AddDays(e.target.value,0), endDate:AddDays(e.target.value, 1), stayDuration: 1});                      
                break;
            case "endDate":
                const duration = GetDurationInDays(_.get(formik.values, "startDate"), e.target.value )
                calculatedEndDate = AddDays(_.get(formik.values, "startDate"), Math.round(duration))
                formik.setValues({ ...formik.values, endDate:calculatedEndDate, stayDuration: Math.round(duration)});                      
                break;
            case "stayDuration":
                calculatedEndDate = AddDays(_.get(formik.values, "startDate"), e.target.value)
                formik.setValues({ ...formik.values, stayDuration:e.target.value, endDate: calculatedEndDate});     
                break;
            case "dependentName":               
                formik.setValues({ ...formik.values, dependentName:_.trimStart(e.target.value)});     
                break;
            case "location":
                SetCurrentLocation(e.target.value)
                formik.setValues({ ...formik.values, location:e.target.value, building: null, parent: null, room: null, bed: null});     
                break;
            case "building":
                OnBuildingChanged(e.target.value)
                formik.setValues({ ...formik.values, building:e.target.value, parentType: GetDefaultParentType(), parent: null, room: null, bed: null});   
                break;
            case "parentType":
                OnParentTypeChanged(e.target.value, formik.values.building.key)
                formik.setValues({...formik.values, parentType: e.target.value, parent: null, room: null, bed: null})
                break;
            case "parent":
                OnParentChanged(e.target.value);
                formik.setValues({...formik.values, parent: e.target.value, room: null, bed: null})
                break;
            case "room":
                OnRoomChanged(e.target.value);
                formik.setValues({...formik.values, room: e.target.value, bed: null})
                break;
            default:
                formik.handleChange(e);   
                break;

        }   
      
    }

    return {data:{}, actions:{onChanged}}


}

export default useCensusForm